import { NgModule } from '@angular/core';
import { CallRetentionPolicyPipe } from './call-retention-policy-pipe';

@NgModule({
   declarations: [CallRetentionPolicyPipe],
   exports: [CallRetentionPolicyPipe],
})
export class CallRetentionPolicyPipeModule {}
